var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"f7"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.htmlData.Title))]),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.dateFormat('mm-dd', new Date(_vm.htmlData.CreateTime)))+"创建")])]),_c('div',{staticClass:"container"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.htmlData.Detail)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }